export default "__VITE_ASSET__BBn9vEwE__"